import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/AboutSection.css';

const AboutSection = () => {
  return (
    <section className="about-section" id="about">
      <div className="container">
        <h2 className="section-title">GIỚI THIỆU</h2>
        
        <div className="about-content">
          <p>
            Phúc An Solutions là đơn vị cung cấp giải pháp công nghệ - thiết kế - xây dựng uy tín, chuyên nghiệp. Chúng tôi mong đến dịch vụ trọn gói từ thi công công trình, lắp đặt camera, thiết kế nội thất, giải pháp CNTT đến năng lượng mặt trời cho doanh nghiệp và cá nhân.
          </p>
          <Link to="/about-us/profile" className="read-more">Xem Thêm &gt;</Link>
        </div>

        <div className="about-menu">
          <div className="about-item">
            <div className="icon-container">
              <img src="/images/PHYLOSOPHY.png" alt="Philosophy" />
            </div>
            <h3>PHYLOSOPHY</h3>
          </div>
          
          <div className="about-item">
            <div className="icon-container">
              <img src="/images/HISTORY.png" alt="History" />
            </div>
            <h3>HISTORY</h3>
          </div>
          
          <div className="about-item">
            <div className="icon-container">
              <img src="/images/PROFILE.png" alt="Profile" />
            </div>
            <h3>PROFILE</h3>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection; 